import { OwnerType } from "./types";

export const transformOwnerType = (res: any): OwnerType => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    icon: res.icon,
  };
};
